// Hand-drawn SVG bar chart from the design — replace with Recharts/Visx when
// the dashboard graduates from mock series to real timeseries data.

interface Bar {
  label: string;
  value: number;
  highlight?: boolean;
}

interface Props {
  data: Bar[];
  width?: number;
  height?: number;
}

export const BarChart = ({ data, width = 580, height = 170 }: Props) => {
  const max = Math.max(...data.map((d) => d.value), 1);
  const bw = width / data.length;
  return (
    <svg width={width} height={height} style={{ display: 'block', width: '100%' }}>
      {[0, 0.25, 0.5, 0.75].map((t, i) => (
        <line
          key={i}
          x1={0}
          x2={width}
          y1={height - 22 - (height - 36) * t}
          y2={height - 22 - (height - 36) * t}
          stroke="#ECECEF"
          strokeDasharray="2 4"
        />
      ))}
      {data.map((d, i) => {
        const bh = (d.value / max) * (height - 36);
        return (
          <g key={i}>
            <rect
              x={i * bw + 4}
              y={height - 22 - bh}
              width={bw - 8}
              height={bh}
              rx={3}
              fill={d.highlight ? '#6366F1' : '#D1D5DB'}
            />
            <text
              x={i * bw + bw / 2}
              y={height - 6}
              fontSize={10}
              fill="#9CA3AF"
              textAnchor="middle"
            >
              {d.label}
            </text>
          </g>
        );
      })}
    </svg>
  );
};
